export const setAlerts = async ({ commit, state }, alertResponse) => {
  if ((alertResponse || null) === null) {
    return;
  }

  if (alertResponse.code === 0 || alertResponse.code === 2) {
    buildAlerts(commit, state, alertResponse.data);
    commit('setAlertError', null);
  } else {
    buildAlerts(commit, state, []);
    commit('setAlertError', alertResponse.message);
  }
};

export const setSystemStatus = async ({ commit, state }, systemResponse) => {
  if ((systemResponse || null) === null) {
    return;
  }

  if (systemResponse.code === 0 || systemResponse.code === 2) {
    if ((systemResponse.data || null) === null) {
      return;
    }

    if (systemResponse.data.length === 0 || systemResponse.data[0] === null) {
      return;
    }

    commit('setSystemStatus', systemResponse.data[0]);
    commit('setAlertError', null);
  } else {
    commit('setSystemStatus', {});
    commit('setSystemStatusError', systemResponse.message);
  }
};

function buildAlerts (commitFn, state, alerts) {
  if ((alerts || null) === null) return;

  alerts.forEach(x => decorateAlert(state, x));
  commitFn('setAlerts', alerts);
}

function decorateAlert (state, alert) {
  switch (alert.priority) {
    case 0:
      alert.priorityColor = 'blue lighten-4';
      break;
    case 1:
      alert.priorityColor = 'green lighten-4';
      break;
    case 2:
      alert.priorityColor = 'amber lighten-4';
      break;
    case 3:
      alert.priorityColor = 'red lighten-3';
      break;
  }

  alert.categoryText = state.categories[alert.category];
  if ((alert.categoryText || null) === null) {
    alert.categoryText = 'Unknown Issue';
  }

  alert.priorityText = state.priorities[alert.priority];
  if ((alert.priorityText || null) === null) {
    alert.priorityText = 'Unknown';
  }

  alert.featureText = state.features[alert.feature];
  if ((alert.featureText || null) === null) {
    alert.featureText = 'Unknown';
  }

  if (alert.systemAlertRecipientType === state.recipientTypes.region) {
    if (alert.region >= 0 && alert.region < 4) {
      alert.affected = `${state.regions[alert.region].name} Region`;
    } else alert.affected = 'Unknown';
  } else if (alert.systemAlertRecipientType === state.recipientTypes.specificAgencies) {
    alert.affected = 'Specific Agencies';
  } else alert.affected = 'All Agencies';
}
